var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('h1',{staticClass:"text-center"},[_vm._v("TC Deliveries CMS")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }